import { FC, ReactNode } from 'react';
import { RegionPlaceholder } from './region-placeholder';
import style from './unit-builder-modal.module.scss';

interface UnitBuilderGunBarrelPaneProps {
  children?: ReactNode;
}

/**
 * Right pane. One slot: in the mock this whole pane is the gun barrel in
 * `editSlotsMode`, which owns the spacing inputs, the chart, the edit rail
 * (Formation, Generate LTD Inventory, Update Geometries, Edit Slot Geometries)
 * and renders the slots table beneath itself.
 *
 * @param {UnitBuilderGunBarrelPaneProps} props - The pane's single slot.
 * @return {JSX.Element} The gun barrel pane.
 */
export const UnitBuilderGunBarrelPane: FC<UnitBuilderGunBarrelPaneProps> = ({
  children,
}) => (
  <div className={style.gunBarrelPane} data-unit-builder-pane>
    {children ?? (
      <RegionPlaceholder
        label="Gun barrel pane"
        source="One component fills this pane — the gun barrel in an edit mode, which renders the slots table itself (as the mock's SciChartGunBarrel does)."
        parts={[
          'Spacing controls — Unit Well Spacing, Cross-line / In-line Setback, Spacing Tolerance, Ignore Existing Development',
          'Gun barrel chart — type-curve-gun-barrel.tsx (exists)',
          'Edit rail — Formation stepper, Generate LTD Inventory (slot_inventory_requests), Update Geometries (geometry_refreshes), Edit Slot Geometries',
          'Slots table — slot-table.tsx (exists), plus the mock’s "Assigned to Unit" / "Intersects the Unit" columns',
        ]}
      />
    )}
  </div>
);
